/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListDeliveryMethodDto } from '../../models/api-response-list-delivery-method-dto';

export interface GetAvailableDeliveryMethods$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getAvailableDeliveryMethods(http: HttpClient, rootUrl: string, params: GetAvailableDeliveryMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListDeliveryMethodDto>> {
  const rb = new RequestBuilder(rootUrl, getAvailableDeliveryMethods.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListDeliveryMethodDto>;
    })
  );
}

getAvailableDeliveryMethods.PATH = '/v1/api/delivery-methods/list';
